import { configureStore } from '@reduxjs/toolkit';
import appSlice from 'app/appSlice';
import topSlice from 'features/Top/topSlice'
import navbarSlice from 'components/Navbars/navbarsSlice'
import promotionSlice from 'features/Promotion/promotionSlice'
import contactSlice from 'features/Contact/contactSlice'
import userSlice from 'features/User/userSlice'
import placeSlice from 'features/Place/placeSlice'
import newSlice from 'features/News/newSlice'
import noticeSlice from 'features/News/noticeSlice'
import pointSlice from 'features/MyPoint/pointSlice'
import paymentSlice from 'features/Payment/paymentSlice'
import entrySlice from 'features/Entries/entrySlice'
import qaSlice from 'features/Questions/qaSlice'
import chatbotSlice from 'components/ChatBot/chatbotSlice.js'

const rootReducer = {
  pp: appSlice,
  navbar: navbarSlice,
  chatbot: chatbotSlice,
  entry: entrySlice,
  contact: contactSlice,
  news:newSlice,
  notice:noticeSlice,
  payment: paymentSlice,
  place: placeSlice,
  promotion:promotionSlice,
  point: pointSlice,
  qa:qaSlice,
  top: topSlice,
  user: userSlice,
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
